import { Checkbox } from '../../../../../../widgets/checkbox';
import { Dialog } from '../../../../../../widgets/dialog';
import { FormControl } from '../../../../../../widgets/formControl';
import { Radio } from '../../../../../../widgets/radio';
import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ComposerAttributeNode, ComposerAttributeOptionNode } from '../../../configurator-components/composer-editors/attributes/composerAttributesModels';

interface ComposerCopyOptionsAttributeOutput {
    optionsToCopy: ComposerAttributeOptionNode[];
    targetAttribute: ComposerAttributeNode;
    replaceExistingOptions?: boolean;
}
interface ComposerCopyOptionsAttributeDialogProps {
    attributesList: ComposerAttributeNode[];
    onConfirm: (attributes: ComposerCopyOptionsAttributeOutput) => void;
}
const ComposerSaveAttributeDialogWindow = styled(Dialog)`
    max-width: 600px;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
`;
const FormInline = styled.div`
display: flex
;
    flex-direction: row;
    align-items: center;
	min-width: 300px;
    gap: 15px;
}
`;

const FormBlock = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    max-height: 300px;
    overflow: auto;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
`;
export const ComposerCopyOptionsAttributeDialog: React.FC<ComposerCopyOptionsAttributeDialogProps> = ({ attributesList, onConfirm }) => {
    const [selectedOptionIds, setSelectedOptionIds] = React.useState<Set<string>>(new Set());
    const [targetAttribute, setTargetAttribute] = React.useState<ComposerAttributeNode | null>(null);
    const [replaceExistingOptions, setReplaceExistingOptions] = React.useState<boolean>(false);
    const handleConfirm = () => {
        if (!targetAttribute) return;
        const result: ComposerCopyOptionsAttributeOutput = {
            optionsToCopy: attributesList.flatMap((attr) => attr.options).filter((opt) => selectedOptionIds.has(opt.id)),
            targetAttribute,
            replaceExistingOptions
        };
        onConfirm(result);
    };

    return (
        <Dialog
            title={T._('Selection of options to copy', 'Admin')}
            windowDecorator={ComposerSaveAttributeDialogWindow}
            buttons={[{ label: T._('Confirm', 'Admin'), onClick: handleConfirm }]}
        >
            <Container>
                <FormControl label={T._('Select the options to copy', 'Admin')}>
                    <div>
                        {attributesList.map((attribute) => {
                            return (
                                <FormBlock key={attribute.id}>
                                    <span>{attribute.name}</span>
                                    {attribute.options.map((opt) => (
                                        <Checkbox
                                            key={opt.id}
                                            label={opt.name}
                                            checked={selectedOptionIds.has(opt.id)}
                                            onChange={(e) => {
                                                const newSet = new Set(selectedOptionIds);
                                                if (e) {
                                                    newSet.add(opt.id);
                                                } else {
                                                    newSet.delete(opt.id);
                                                }
                                                setSelectedOptionIds(newSet);
                                            }}
                                        />
                                    ))}
                                </FormBlock>
                            );
                        })}
                    </div>
                </FormControl>
                <FormControl label={T._('Select the target attribute', 'Admin')}>
                    <FormInline>
                        <FormBlock>
                            {attributesList.map((attr) => (
                                <Radio
                                    key={attr.id}
                                    name={attr.name}
                                    value={attr.id}
                                    label={attr.name}
                                    checked={targetAttribute?.id === attr.id}
                                    onSelect={() => setTargetAttribute(attr)}
                                />
                            ))}
                        </FormBlock>
                    </FormInline>
                </FormControl>
                <FormControl label={T._('Options handling', 'Admin')}>
                    <FormInline>
                        <Checkbox
                            label={T._('Replace existing options in the target attribute', 'Admin')}
                            checked={replaceExistingOptions}
                            onChange={(e) => setReplaceExistingOptions(e)}
                        />
                    </FormInline>
                </FormControl>
            </Container>
        </Dialog>
    );
};
